<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">

  <mat-card appearance="outlined">
    <mat-card-title>Info: Redirect</mat-card-title>
    <table>
      <tr>
        <td>title:</td>
        <td>{{redirect.title}}</td>
      </tr>
      <tr>
        <td>Screen UUID:</td>
        <td>{{redirect.screenUUID}}</td>
      </tr>
      <tr>
        <td>description:</td>
        <td>
          <ng-container *ngIf="redirect.detail">{{redirect.detail.description}}</ng-container>
        </td>
      </tr>
      <tr *ngIf="redirect.location && redirect.location.coordinates[0]">
        <td>location:</td>
        <td>
          <table>
            <tr>
              <td>Longitude</td>
              <td>{{redirect.location.coordinates[0]}}</td>
            </tr>
            <tr>
              <td>Latitude</td>
              <td>{{redirect.location.coordinates[1]}}</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>last visit:</td>
        <td>{{redirect.lastVisit | date: 'dd-MMMM-yyyy HH:mm'}}</td>
      </tr>
      <tr>
        <td>visit count:</td>
        <td>{{redirect.visitCount}}</td>
      </tr>
    </table>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="screen.server.url">
    <mat-card-title>Url:</mat-card-title>
    <i class="material-icons">link</i>
    <a href="{{this.redirectUrl}}" target="_blank">{{this.redirectUrl}}</a>
  </mat-card>

  <div *ngIf="screen" class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="screen">
    <mat-card-title>Info: Screen</mat-card-title>
    <table>
      <tr>
        <td>remark:</td>
        <td>{{screen.remark}}</td>
      </tr>
      <tr>
        <td>isTouch2015:</td>
        <td>
          <ng-container *ngIf="screen.isTouch2015"><i class="material-icons">check_box</i></ng-container>
          <ng-container *ngIf="!screen.isTouch2015"><i class="material-icons">indeterminate_check_box</i></ng-container>
        </td>
      </tr>
      <tr>
        <td>ibexCustomerId:</td>
        <td>{{screen.ibexCustomerId}}</td>
      </tr>
      <tr>
        <td>IbexId:</td>
        <td>{{screen.ibexId}}</td>
      </tr>
      <tr>
        <td>productName:</td>
        <td>{{screen.productName}}</td>
      </tr>
    </table>
  </mat-card>
  <div *ngIf="customer" class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="customer">
    <mat-card-title>Info: Customer</mat-card-title>
    <table>
      <tr>
        <td>company:</td>
        <td>{{customer.company}}</td>
      </tr>
      <tr>
        <td>touch2goCount:</td>
        <td>{{customer.touch2goCount}}</td>
      </tr>
      <tr>
        <td>touch2015Count:</td>
        <td>{{customer.touch2015Count}}</td>
      </tr>
    </table>
  </mat-card>

</page-content>
